import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureSession } from '@/features/auth/api';
import { pickOrgId, session } from '@/lib/auth/session';
import { DataLoadingScreen } from '@/screens/onboarding/DataLoadingScreen';

/** The waiting room after the wizard: signed in and verified; no onboarding check (the org is onboarded by now). */
export const Route = createFileRoute('/onboarding/data-loading')({
  beforeLoad: async ({ location }) => {
    const s = await ensureSession();
    if (!s.user) throw redirect({ to: '/sign-in', state: { next: location.href } });
    if (!s.user.email_verified) throw redirect({ to: '/verify-email', state: { email: s.user.email } });
    session.set({ orgId: pickOrgId(s.user) });
  },
  component: DataLoadingScreen,
});
